import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

export default function RlPageHeader({ title, subtitle, right }) {
  const history = useHistory();
  return (
    <AppBar
      position="sticky"
      color="inherit"
      elevation={0}
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        backgroundColor: '#fff',
      }}
    >
      <Toolbar sx={{ minHeight: 56 }}>
        <IconButton edge="start" onClick={() => history.goBack()} size="small">
          <ArrowBackIcon />
        </IconButton>
        <Box sx={{ flex: 1, ml: 1 }}>
          <Typography variant="h6" sx={{ fontSize: 17, fontWeight: 600 }}>{title}</Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary">{subtitle}</Typography>
          )}
        </Box>
        {right}
      </Toolbar>
    </AppBar>
  );
}
